module.exports = "/fonts/fa-solid-900.woff?6661d6b3521b4c480ba759e4b9e480c1";